import { fmtAmount, fmtDate, PartyAvatar } from '../lib/helpers';

export function HomePage({ summary, parties, onNav, onPartyClick }) {
  if (!summary) return null;

  const topOwing = [...parties]
    .filter(p => p.balance > 0)
    .sort((a, b) => b.balance - a.balance)
    .slice(0, 5);

  return (
    <div className="content">
      <div className="content-inner">
        {/* Summary Cards */}
        <div className="summary-row">
          <div className="summary-card green">
            <div className="sc-label">You will Get 📥</div>
            <div className="sc-amount">{fmtAmount(summary.you_will_get)}</div>
            <div className="sc-sub">Total receivable</div>
            <div className="sc-icon">💚</div>
          </div>
          <div className="summary-card red">
            <div className="sc-label">You will Give 📤</div>
            <div className="sc-amount">{fmtAmount(summary.you_will_give)}</div>
            <div className="sc-sub">Total payable</div>
            <div className="sc-icon">❤️</div>
          </div>
        </div>

        {/* Net Balance */}
        <div style={{
          background: 'var(--surface)', borderRadius: 12, padding: '14px 16px',
          marginBottom: '1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          boxShadow: 'var(--shadow)',
        }}>
          <div>
            <div style={{ fontSize: 12, color: 'var(--text-faint)', fontWeight: 500 }}>NET BALANCE</div>
            <div style={{ fontSize: 22, fontWeight: 700, marginTop: 3,
              color: summary.you_will_get >= summary.you_will_give ? 'var(--green-dark)' : 'var(--red-dark)' }}>
              {fmtAmount(Math.abs(summary.you_will_get - summary.you_will_give))}
            </div>
          </div>
          <span className={`net-pill ${summary.you_will_get >= summary.you_will_give ? 'positive' : 'negative'}`}>
            {summary.you_will_get >= summary.you_will_give ? '✅ You will get' : '⚠️ You will give'}
          </span>
        </div>

        {/* Parties that owe you */}
        {topOwing.length > 0 && (
          <>
            <div className="section-title">
              Top Pending – Will Get
              <button className="btn btn-sm" onClick={() => onNav('parties')}>View all</button>
            </div>
            <div className="party-list" style={{ marginBottom: '1.25rem' }}>
              {topOwing.map(p => (
                <div key={p.id} className="party-row" onClick={() => onPartyClick(p)}>
                  <PartyAvatar name={p.name} />
                  <div className="party-info">
                    <div className="party-name">{p.name}</div>
                    <div className="party-phone">{p.phone || 'No phone'}</div>
                  </div>
                  <div className="party-balance">
                    <div className="party-bal-amount" style={{ color: 'var(--green-dark)' }}>
                      {fmtAmount(p.balance)}
                    </div>
                    <div className="party-bal-label" style={{ color: 'var(--green-dark)' }}>Will Get</div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {/* Recent Transactions */}
        {summary.recent?.length > 0 && (
          <>
            <div className="section-title">
              Recent Transactions
              <button className="btn btn-sm" onClick={() => onNav('cashbook')}>View all</button>
            </div>
            <div className="txn-list">
              {summary.recent.map(t => (
                <div key={t.id} className="txn-row">
                  <div className={`txn-dot ${t.type}`}>
                    {t.type === 'credit' ? '📥' : '📤'}
                  </div>
                  <div className="txn-info">
                    <div className="txn-note">{t.note || (t.type === 'credit' ? 'Credit entry' : 'Debit entry')}</div>
                    <div className="txn-party">👤 {t.party_name}</div>
                    <div className="txn-date">{fmtDate(t.date)}</div>
                  </div>
                  <div className="txn-right">
                    <div className={`txn-amount ${t.type}`}>{fmtAmount(t.amount)}</div>
                    <div className={`txn-label ${t.type}`}>{t.type === 'credit' ? 'Will Get' : 'Will Give'}</div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
